module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar _uuid = Math.floor(Math.random() * 9999999) + '-' + content_id;\n%>\n<article class=\"grid-view-item\">\n    <a class=\"link vilynx-redirect <%= lockLevel !== 'none' ? lockLevel :'' %>\"\n       vilynx-id=\"<%= content_id %>\"\n       href=\"<%= url %>\"\n       aa-link=\"<%= aaLink %>\"\n       data-tracking=\"<%= dataTracking %>\">\n\n        <div class=\"thumb-wrapper\">\n\n            <img class=\"thumb lazy\" data-src=\"<%= thumbUrl %>\" alt=\"<%= series_title %> - <%= episode_title %>\"/>\n\n            <%# RATINGS ICON %>\n            <% if (typeof ratingIcon !== 'undefined'){ %>\n                <img class=\"ratings-icon lazy\" data-src=\"<%= ratingIcon %>\" alt=\"<%= ratingText %>\" />\n            <% } %>\n\n            <%# PROGRESS BAR %>\n            <% if(typeof progress !== 'undefined' && progress > 0){ %>\n            <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #0037C5, #0064FF);\n        background-image: linear-gradient(135deg, #0037C5, #0064FF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n            <% } %>\n\n            <% if(lockLevel === 'subscribe' && status !== 'AVAILABLE') { %>\n                <div class=\"subscribe-gradient\"></div>\n                <span class=\"label subscribe\" <% if (navigator.userAgent.indexOf('Win') != -1) { %> style=\"padding-bottom: 7px !important\" <% } %> > <%= labelSubscribe %></span>\n            <% } else if(lockLevel === 'showtimelock' || lockLevel === 'tvelock') { %>\n                <span class=\"label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </span>\n            <% }else { %>\n            <div class=\"play label circle-sm\">\n                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                     xmlns=\"http://www.w3.org/2000/svg\">\n                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\"\n                            fill=\"none\" cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                </svg>\n            </div>\n            <% } %>\n        </div>\n\n\n    <div class=\"info-wrapper\">\n\n        <% if(jQuery.inArray(\"Seasonless\", videoProperties) !== -1){\n                noSeasons = true;\n            }\n        %>\n\n        <% if(jQuery.inArray(\"Episodeless\", videoProperties) !== -1){\n                noEpisodes = true;\n        }\n        %>\n\n\n        <% if(episode_number != null && episode_number != '' && type !== 'Clip'){ %>\n            <% if( typeof noSeasons == 'undefined'){ %>\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season <%= season_number %>\" title=\"<%= seasonTitle %>\">\n                    <%= seasonAbbr %>\n                    </abbr>\n                </span>\n             <% } %>\n            <% if( typeof noEpisodes == 'undefined'){ %>\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode <%= episode_number %>\" title=\"<%= episodeNumberTitle %>\">\n                    <%= episodeAbbr %>\n                    </abbr>\n                </span>\n            <% } %>\n\n            <% if( typeof noSeasons == 'undefined' && typeof noEpisodes == 'undefined' ){ %>\n                    <span class=\"meta-gray meta-airdate\">\n             <% }else{ %>\n                    <span class=\"meta-gray\">\n             <% } %>\n                        <time datetime=\"<%= airdate_iso %>\">\n                            <%= airdate %>\n                        </time>\n                    </span>\n            <% } %>\n\n        <% if(type === 'Clip') { %>\n        <span class=\"meta-gray\" itemprop=\"duration\" content=\"<%= duration %>\">\n                <%= duration %>\n        </span>\n        <% } %>\n\n        <%# TITLE %>\n        <% if(displayTitle){ %>\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                <%= displayTitle %>\n            </span>\n        </div>\n        <% } %>\n\n    </div>\n    </a>\n</article>\n"
  , __filename = "node_modules/.pnpm/git+github.com+cbsi-cbscom+web-package-coreui@c7ca63cf087f0862a8685d430edccb6ed7397685_fetch-_yhbmh4nmn3zdx5pohrpmqz62fi/node_modules/cbs-core-ui/src/js/templates/__gridView.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
var _uuid = Math.floor(Math.random() * 9999999) + '-' + content_id;

    ; __line = 3
    ; __append("\n<article class=\"grid-view-item\">\n    <a class=\"link vilynx-redirect ")
    ; __line = 5
    ; __append(escapeFn( lockLevel !== 'none' ? lockLevel :'' ))
    ; __append("\"\n       vilynx-id=\"")
    ; __line = 6
    ; __append(escapeFn( content_id ))
    ; __append("\"\n       href=\"")
    ; __line = 7
    ; __append(escapeFn( url ))
    ; __append("\"\n       aa-link=\"")
    ; __line = 8
    ; __append(escapeFn( aaLink ))
    ; __append("\"\n       data-tracking=\"")
    ; __line = 9
    ; __append(escapeFn( dataTracking ))
    ; __append("\">\n\n        <div class=\"thumb-wrapper\">\n\n            <img class=\"thumb lazy\" data-src=\"")
    ; __line = 13
    ; __append(escapeFn( thumbUrl ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( series_title ))
    ; __append(" - ")
    ; __append(escapeFn( episode_title ))
    ; __append("\"/>\n\n            ")
    ; __line = 15
    ; __append("\n            ")
    ; __line = 16
    ;  if (typeof ratingIcon !== 'undefined'){ 
    ; __append("\n                <img class=\"ratings-icon lazy\" data-src=\"")
    ; __line = 17
    ; __append(escapeFn( ratingIcon ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( ratingText ))
    ; __append("\" />\n            ")
    ; __line = 18
    ;  } 
    ; __append("\n\n            ")
    ; __line = 20
    ; __append("\n            ")
    ; __line = 21
    ;  if(typeof progress !== 'undefined' && progress > 0){ 
    ; __append("\n            ")
    ; __line = 22
    ; __append("\n")
    ; __line = 23
    ; __append("\n")
    ; __line = 24
    ; __append("\n")
    ; __line = 25
    ; __append("\n")
    ; __line = 26
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 29
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: 100%;\n        height: 4px;\n        border-radius: 10px;\n        background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    #progress-bar-")
    ; __line = 36
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #0037C5, #0064FF);\n        background-image: linear-gradient(135deg, #0037C5, #0064FF);\n        height: 4px;\n        border-radius: 10px 0 0 10px;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 44
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time\n        -moz-animation: slideProgress-")
    ; __line = 46
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 47
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 50
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 58
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 64
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 69
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 73
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 78
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 82
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 87
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 93
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 94
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 96
    ;  } 
    ; __append("\n            ")
    ; __line = 97
    ;  } 
    ; __append("\n\n            ")
    ; __line = 99
    ;  if(lockLevel === 'subscribe' && status !== 'AVAILABLE') { 
    ; __append("\n                <div class=\"subscribe-gradient\"></div>\n                <span class=\"label subscribe\" ")
    ; __line = 101
    ;  if (navigator.userAgent.indexOf('Win') != -1) { 
    ; __append(" style=\"padding-bottom: 7px !important\" ")
    ;  } 
    ; __append(" > ")
    ; __append(escapeFn( labelSubscribe ))
    ; __append("</span>\n            ")
    ; __line = 102
    ;  } else if(lockLevel === 'showtimelock' || lockLevel === 'tvelock') { 
    ; __append("\n                <span class=\"label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </span>\n            ")
    ; __line = 106
    ;  }else { 
    ; __append("\n            <div class=\"play label circle-sm\">\n                <svg class=\"svg-loader\" viewbox=\"0 0 33.83098862 33.83098862\" width=\"30\" height=\"30\"\n                     xmlns=\"http://www.w3.org/2000/svg\">\n                    <circle class=\"svg-loader__circle\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-dasharray=\"100\"\n                            fill=\"none\" cx=\"16.91549431\" cy=\"16.91549431\" r=\"15.91549431\"/>\n                </svg>\n            </div>\n            ")
    ; __line = 114
    ;  } 
    ; __append("\n        </div>\n\n\n    <div class=\"info-wrapper\">\n\n        ")
    ; __line = 120
    ;  if(jQuery.inArray("Seasonless", videoProperties) !== -1){
                noSeasons = true;
            }
        
    ; __line = 123
    ; __append("\n\n        ")
    ; __line = 125
    ;  if(jQuery.inArray("Episodeless", videoProperties) !== -1){
                noEpisodes = true;
        }
        
    ; __line = 128
    ; __append("\n\n\n        ")
    ; __line = 131
    ;  if(episode_number != null && episode_number != '' && type !== 'Clip'){ 
    ; __append("\n            ")
    ; __line = 132
    ;  if( typeof noSeasons == 'undefined'){ 
    ; __append("\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season ")
    ; __line = 134
    ; __append(escapeFn( season_number ))
    ; __append("\" title=\"")
    ; __append(escapeFn( seasonTitle ))
    ; __append("\">\n                    ")
    ; __line = 135
    ; __append(escapeFn( seasonAbbr ))
    ; __append("\n                    </abbr>\n                </span>\n             ")
    ; __line = 138
    ;  } 
    ; __append("\n            ")
    ; __line = 139
    ;  if( typeof noEpisodes == 'undefined'){ 
    ; __append("\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode ")
    ; __line = 141
    ; __append(escapeFn( episode_number ))
    ; __append("\" title=\"")
    ; __append(escapeFn( episodeNumberTitle ))
    ; __append("\">\n                    ")
    ; __line = 142
    ; __append(escapeFn( episodeAbbr ))
    ; __append("\n                    </abbr>\n                </span>\n            ")
    ; __line = 145
    ;  } 
    ; __append("\n\n            ")
    ; __line = 147
    ;  if( typeof noSeasons == 'undefined' && typeof noEpisodes == 'undefined' ){ 
    ; __append("\n                    <span class=\"meta-gray meta-airdate\">\n             ")
    ; __line = 149
    ;  }else{ 
    ; __append("\n                    <span class=\"meta-gray\">\n             ")
    ; __line = 151
    ;  } 
    ; __append("\n                        <time datetime=\"")
    ; __line = 152
    ; __append(escapeFn( airdate_iso ))
    ; __append("\">\n                            ")
    ; __line = 153
    ; __append(escapeFn( airdate ))
    ; __append("\n                        </time>\n                    </span>\n            ")
    ; __line = 156
    ;  } 
    ; __append("\n\n        ")
    ; __line = 158
    ;  if(type === 'Clip') { 
    ; __append("\n        <span class=\"meta-gray\" itemprop=\"duration\" content=\"")
    ; __line = 159
    ; __append(escapeFn( duration ))
    ; __append("\">\n                ")
    ; __line = 160
    ; __append(escapeFn( duration ))
    ; __append("\n        </span>\n        ")
    ; __line = 162
    ;  } 
    ; __append("\n\n        ")
    ; __line = 164
    ; __append("\n        ")
    ; __line = 165
    ;  if(displayTitle){ 
    ; __append("\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                ")
    ; __line = 168
    ; __append(escapeFn( displayTitle ))
    ; __append("\n            </span>\n        </div>\n        ")
    ; __line = 171
    ;  } 
    ; __append("\n\n    </div>\n    </a>\n</article>\n")
    ; __line = 176
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git+github.com+cbsi-cbscom+web-package-coreui@c7ca63cf087f0862a8685d430edccb6ed7397685_fetch-_yhbmh4nmn3zdx5pohrpmqz62fi/node_modules/cbs-core-ui/src/js/templates/__gridView.tpl"

}